import { Badges } from "../../AbstractElements";
import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { MoreVertical } from "react-feather";
import { Link } from "react-router-dom";
import { showWarningAlert } from "../../utils/showWarningAlert";
import { useTranslation } from "react-i18next";
import { SMSColumnType, UserListTableDataColumnType } from "../../types/users/UserTypes";


const ActivityActionBadge = ({ status }: { status: string }) => (
  <Badges
    color="transparent"
    className={`badge-light-${
      status === "StandBy"
        ? "danger"
        
        : "success"
    }`}
  >
    {status}
  </Badges>
);

const ErrorListTableAction: React.FC<{ row: SMSColumnType }> = ({
    row,
  }) => {
     
    const { t } = useTranslation();
    const handleActive = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to Active ${row.sms_gateway_name}?`,
        confirmButtonText: t("Confirm"),
        onConfirm: () => {
          // Block logic here
        },
      });
    };
  
    const handleInactive = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to InActive ${row.sms_gateway_name}?`,
        confirmButtonText: t("Confirm"),
        onConfirm: () => {
          // Unblock logic here
        },
      });
    };
  
    return (
      <UncontrolledDropdown>
        <DropdownToggle  tag="span" className="cursor-pointer">
          <MoreVertical size={18} />
        </DropdownToggle>
        <DropdownMenu>
      
          <Link to={`${process.env.PUBLIC_URL}/mastersettings/viewsmsgateway/${row.sms_gateway_id}`}>
            <DropdownItem >{t("View")}</DropdownItem>
          </Link>
          <Link to={`${process.env.PUBLIC_URL}/mastersettings/smsgateway/edit/${row.sms_gateway_id}`}>
       
       <DropdownItem >{t("Edit")}</DropdownItem>
     </Link>
          {row.status === "StandBy" && <DropdownItem onClick={handleActive}>{t("Default")}</DropdownItem>}
          {row.status === "Default" && <DropdownItem onClick={handleInactive}>{t("StandBy")}</DropdownItem>}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };
  


export const SMsGatewayColumns = (t: TFunction): TableColumn<any>[] => [
    {
        name: t("Sl.No"),
        selector: (row) => row.sms_gateway_id,
        sortable: true,
        width: "100px",
      },
      {
        name: t("GatewayName"),
        selector: (row) => row.sms_gateway_name,
        sortable: true,
       
      },
      {
        name: t("GatewayURL"),
        selector: (row) => row.sms_gateway_url,
        sortable: true,
      },
      {
        name: t("SMSreqFormat"),
        selector: (row) => row.sms_gateway_request_format,
        sortable: true,
      },
      {
        name: t("Status"),
        // selector: (row) => row.status,
        selector: (row) => <ActivityActionBadge status={row.status} />,
        sortable: true,
      },
      {
        name: t("Action"),
        cell: (row) => <ErrorListTableAction row={row} />,
        sortable: true,
      },
    
];


